<template>
  <div class="faq-item">
    <div
      class="d-flex justify-content-between align-items-center"
      @click="open"
    >
      <h3 class="m-0">
        {{ question }}
      </h3>
      <i 
        class="icon rotate  far fa-angle-down"
        :class="{
          down: isOpen,
        }"
      ></i>
    </div>
    <div class="mt-3" v-show="isOpen">
      <div class="faq-item-content" v-html="answer"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StudioFaqPreview',
  props: {
    question: {
      type: String,
      default: null,
    },
    answer: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    open() {
      this.isOpen = !this.isOpen;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/components-variables.scss';

.faq-item {
  border-top: 1px solid $light-gray;
  padding: 1rem 0;
  cursor: pointer;
  &:last-child {
    border-bottom: 1px solid $light-gray;
  }
}

.icon {
  height: 25px;
  width: auto;
  color: $light-gray;
}
</style>

<style lang="scss">
.faq-item-content *:last-child {
  margin-bottom: 0;
}
</style>
